<template>
  <article>
    <v-container fluid>
      <v-row justify="center" class="mb-5">
        <img src="/img/logo-192w.png" />
      </v-row>

      <v-row class="mb-5" justify="center">
        <v-col cols="12" sm="8" lg="3" class="text-center">
          <h3>Pozabljeno geslo</h3>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="4" lg="3">
          <v-card class="login pa-lg-4 pa-2" :elevation="$vuetify.breakpoint.smAndUp > 0 ? 1 : 0">
            <v-form v-model="valid" ref="form">
              <v-text-field label="E-pošta" type="text" v-model="email" flat required placeholder="Vaš email" prepend-icon="mdi-email" />
              <v-btn color="primary" @click="doSendEmail">Pošlji zahtevek</v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4" lg="3" class="text-right">
          <router-link to="/login">Prijava</router-link>
        </v-col>
      </v-row>
    </v-container>
  </article>
</template>

<script>
  export default {
    data: () => ({
      valid: false,
      email: ""
    }),
    methods: {
      doSendEmail() {
        // send email
      }
    }
  };
</script>

<style lang="scss" scoped>
  article {
    width: 100vw;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    align-content: center;
  }
</style>
